import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArchiveRestore, FileText, Image as ImageIcon } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function DeletedFiles() {
  const { t, fmt } = useI18n();
  const [items, setItems] = useState([]);

  const load = () => api.get("/attachments/deleted").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const restore = async (a) => {
    try { await api.post(`/attachments/${a.id}/restore`); toast.success(t("fileRestored")); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl sm:text-5xl font-extrabold">{t("deletedFiles")}</h1>
        <p className="text-slate-500 mt-4">{t("deletedFilesHint")}</p>
      </div>
      <div className="bg-white border rounded-lg overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            {["fileName", "plate", "shelf", "attachedTo", "deletedBy", "deletedAt", "actions"].map((h) => <TableHead key={h} className="text-start">{t(h)}</TableHead>)}
          </TableRow></TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-slate-500 py-10" data-testid="deleted-empty">{t("noDeletedFiles")}</TableCell></TableRow>}
            {items.map((a) => (
              <TableRow key={a.id} data-testid={`deleted-row-${a.id}`}>
                <TableCell>
                  <span className="flex items-center gap-2 max-w-[260px]">
                    {a.content_type.startsWith("image/") ? <ImageIcon className="w-4 h-4 text-sky-600 shrink-0" /> : <FileText className="w-4 h-4 text-slate-500 shrink-0" />}
                    <span className="truncate font-semibold" dir="auto">{a.original_filename}</span>
                  </span>
                </TableCell>
                <TableCell>{a.plate_number ? <span className="plate text-xs">{a.plate_number}</span> : "-"}</TableCell>
                <TableCell className="font-bold">{a.shelf_number ?? "-"}</TableCell>
                <TableCell className="text-sm">{a.voucher_number === "invoices" ? t("invoices") : `${t("voucherNo")} ${a.voucher_number}`}</TableCell>
                <TableCell className="text-sm">{a.deleted_by || "-"}</TableCell>
                <TableCell className="text-sm whitespace-nowrap">{fmt(a.deleted_at)}</TableCell>
                <TableCell>
                  <Button size="sm" data-testid={`restore-btn-${a.id}`} className="bg-[#F5BE25] hover:bg-[#E5AC12] text-[#3E3E40]" onClick={() => restore(a)}>
                    <ArchiveRestore className="w-4 h-4" />{t("restore")}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
